import { useState } from "react";
import { Container, Row, Col, Card, Form } from "react-bootstrap";
import Select from "react-select";
import "bootstrap/dist/css/bootstrap.min.css"; // Import Bootstrap CSS

export default function CakeBuilder() {
    // State for each layer
    const [numTiers, setNumTiers] = useState("1"); // Default to 1-tier
    const [cakeColor, setCakeColor] = useState("white");
    const [icingTypes, setIcingTypes] = useState([]);
    const [topDecorations, setTopDecorations] = useState([]);

    // Mapping selection to image filenames
    const cakeImages = {
        white: `/cake-builder/vanilla_${numTiers}tier.png`,
        pink: `/cake-builder/pink_${numTiers}tier.png`,
        green: `/cake-builder/green_${numTiers}tier.png`,
        blue: `/cake-builder/blue_${numTiers}tier.png`,
    };

    const icingImages = {
        "icing-swirls": `/cake-builder/icing-swirls_${numTiers}tier.png`,
        fruit: `/cake-builder/fruit_${numTiers}tier.png`,
        sprinkles: `/cake-builder/sprinkles_${numTiers}tier.png`,
    };

    const topImages = {
        balloons: `/cake-builder/balloons_${numTiers}tier.png`,
        "happy birthday sign": `/cake-builder/happybirthday_${numTiers}tier.png`,
    };

    // Options for react-select
    const icingOptions = [
        { value: "icing-swirls", label: "Icing Swirls" },
        { value: "fruit", label: "Fruit" },
        { value: "sprinkles", label: "Sprinkles" },
    ];

    const topOptions = [
        { value: "balloons", label: "Balloons" },
        { value: "happy birthday sign", label: "Happy Birthday Sign" },
    ];

    return (
        <Container className="mt-4">
            <Card className="p-4 shadow" style={{ position: "relative", overflow: "visible" }}>
                <h2 className="text-center mb-4">Build Your Cake</h2>
                <Row>
                    {/* Left Column: Controls */}
                    <Col md={6} className="pb-4 pb-md-0">
                        <Card className="p-3" style={{ position: "relative", overflow: "visible" }}>
                            {/* Number of Tiers Selection */}
                            <Form.Group className="mb-3">
                                <Form.Label>Number of Tiers</Form.Label>
                                <Form.Select 
                                    value={numTiers} 
                                    onChange={(e) => setNumTiers(e.target.value)}
                                    style={{ position: "relative", zIndex: 1050 }}
                                >
                                    <option value="1">1 Tier</option>
                                    <option value="2">2 Tiers</option>
                                </Form.Select>
                            </Form.Group>

                            {/* Cake Color Selection */}
                            <Form.Group className="mb-3">
                                <Form.Label>Cake Color</Form.Label>
                                <Form.Select 
                                    value={cakeColor} 
                                    onChange={(e) => setCakeColor(e.target.value)}
                                    style={{ position: "relative", zIndex: 1050 }}
                                >
                                    <option value="white">White</option>
                                    <option value="pink">Pink</option>
                                    <option value="green">Green</option>
                                    <option value="blue">Blue</option>
                                </Form.Select>
                            </Form.Group>

                            {/* Icing Type Multi-Select */}
                            <Form.Group className="mb-3">
                                <Form.Label>Decorations</Form.Label>
                                <Select
                                    options={icingOptions}
                                    isMulti
                                    value={icingOptions.filter((option) => icingTypes.includes(option.value))}
                                    onChange={(selected) => setIcingTypes(selected.map((s) => s.value))}
                                    styles={{
                                        menu: (provided) => ({
                                            ...provided,
                                            zIndex: 1050,
                                            position: "absolute",
                                        }),
                                    }}
                                />
                            </Form.Group>

                            {/* Topper Multi-Select */}
                            <Form.Group className="mb-3">
                                <Form.Label>Topper</Form.Label>
                                <Select
                                    options={topOptions}
                                    isMulti
                                    value={topOptions.filter((option) => topDecorations.includes(option.value))}
                                    onChange={(selected) => setTopDecorations(selected.map((s) => s.value))}
                                    styles={{
                                        menu: (provided) => ({
                                            ...provided,
                                            zIndex: 1050,
                                            position: "absolute",
                                        }),
                                    }}
                                />
                            </Form.Group>
                        </Card>
                    </Col>

                    {/* Right Column: Cake Preview */}
                    <Col md={6} className="d-flex justify-content-center align-items-center">
                        <div
                            style={{
                                position: "relative",
                                width: "300px",
                                height: "300px",
                                border: "1px solid gray",
                                display: "inline-block",
                            }}
                        >
                            {/* Bottom Cake Layer */}
                            <img
                                src={cakeImages[cakeColor]}
                                alt="Cake Base"
                                style={{
                                    position: "absolute",
                                    top: "0",
                                    left: "0",
                                    width: "100%",
                                    height: "auto",
                                    zIndex: 1,
                                }}
                            />

                            {/* Middle Icing Layers (Multiple) */}
                            {icingTypes.map((icing, index) => (
                                <img
                                    key={icing}
                                    src={icingImages[icing]}
                                    alt="Icing Layer"
                                    style={{
                                        position: "absolute",
                                        top: "0",
                                        left: "0",
                                        width: "100%",
                                        height: "auto",
                                        zIndex: 2 + index, // Stack icing layers dynamically
                                    }}
                                />
                            ))}

                            {/* Top Decoration Layers (Multiple) */}
                            {topDecorations.map((decoration, index) => (
                                <img
                                    key={decoration}
                                    src={topImages[decoration]}
                                    alt="Top Decoration"
                                    style={{
                                        position: "absolute",
                                        top: "0",
                                        left: "0",
                                        width: "100%",
                                        height: "auto",
                                        zIndex: 10 + index, // Ensure it stays above icing layers
                                    }}
                                />
                            ))}
                        </div>
                    </Col>
                </Row>
            </Card>
        </Container>
    );
}
